import { FC } from "react"
import AlertSoundRadioButton from "../AlertSoundRadioButton"
import { AlertSoundFrequency, alertFrequencyOptions } from "../files"

interface AlertSoundFrequencyOptionsListProps {
   isEditing: boolean
   soundFrequency: AlertSoundFrequency
   formSoundFrequency: AlertSoundFrequency
   setFormSoundFrequency: (soundFrequency: AlertSoundFrequency) => void
}

const AlertSoundFrequencyOptionsList: FC<
   AlertSoundFrequencyOptionsListProps
> = ({
   isEditing,
   soundFrequency,
   formSoundFrequency,
   setFormSoundFrequency,
}) => {
   return (
      <>
         {isEditing ? (
            <>
               {alertFrequencyOptions.map((alertFrequencyOption, index) => {
                  return (
                     <tr key={`alert-sound-frequency-${index}`}>
                        <td>
                           <AlertSoundRadioButton
                              value={alertFrequencyOption.value}
                              label={alertFrequencyOption.label}
                              id={`alert-sound-frequency-${index}`}
                              onChange={() => {
                                 setFormSoundFrequency(alertFrequencyOption)
                              }}
                              checked={
                                 formSoundFrequency.value ===
                                 alertFrequencyOption.value
                              }
                           />
                        </td>
                     </tr>
                  )
               })}
            </>
         ) : (
            <tr key="alert-sound-frequency">
               <td>
                  <span>{soundFrequency.label}</span>
               </td>
            </tr>
         )}
      </>
   )
}

export default AlertSoundFrequencyOptionsList
